export default "__VITE_PUBLIC_ASSET__be3c9c4f__"